import { SoftwareIntegrationDto } from "@inosio/payments-sdk";
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";

type PMIntegration={
    portfolioName:string,
    isSending: boolean,
    isSuccess: boolean,
    apiKeyReceived: boolean,
    error: string | null,
    apiKey: string,
    existingPortfolios: Array<SoftwareIntegrationDto>
}
const getInitialState= () =>{
    return{
        portfolioName:'',
        isSending: false,
        isSuccess:false,
        apiKeyReceived: false,
        error:'',
        apiKey:'',
        existingPortfolios:[]
    } as PMIntegration
}
const pmIntegrationSlice= createSlice({
    name:"pmIntegrations",
    initialState: getInitialState(),
    reducers:{
        getCreateNewIntegration(state, action){
            state.isSending= true;
            state.error= null
        },
        getExistingIntegrations(state,action){
            state.isSending= true;
            state.error= null
        },
        getUpdatePromasApiKey(state, action){
            state.isSending=true;
            state.error= null
        },
        getNullifyApiKey(state, action){
            state.apiKey='';
            state.error= null
        },
        setUpdatePromasApiKey(state, action){
            state.isSending=false
            state.apiKey= action.payload
        },
        setExistingPortfolios(state, action){
            return { ...state, isSending: false, existingPortfolios: [...action.payload] }
        },
        setSendPortfolioName(state,action){
            state.isSending=false
            state.isSuccess=true
            state.apiKey= action.payload
        },
        setPmIntegrationsError(state, action){
            state.error= action.payload.message
        }
    }
})

export const{
    getCreateNewIntegration,
    getExistingIntegrations,
    getUpdatePromasApiKey,
    getNullifyApiKey,
    setUpdatePromasApiKey,
    setExistingPortfolios,
    setSendPortfolioName,
    setPmIntegrationsError
}= pmIntegrationSlice.actions

export default pmIntegrationSlice.reducer;

export const selectIntegrationState = (state: RootState) => state.pmIntegrationState;
